import requestService from '../requestService';

export default {
	async loginFromAdmin(form) {
		const response = await requestService.post(`/auth/adminAuth`, form)
		return response?.data
	},
}